import { render, staticRenderFns } from "./employeeMonthlyReviews.vue?vue&type=template&id=164b9289"
import script from "./employeeMonthlyReviews.vue?vue&type=script&lang=js"
export * from "./employeeMonthlyReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports